export enum OAUTH_PROVIDER {
  google = 'google',
  apple = 'apple',
}
